module.exports = __webpack_public_path__ + "static/flow-fd685ce5d579d9bc53e7d08101f38b1c.mp4";